import { axiosGet, axiosPost } from "../../../../react_axios/Axios";
import { headers, getVisitorMeetingMasterListUrl, insertUpdateVisitorMeetingMasterUrl, deleteVisitorMeetingMasterUrl, GET_VISITOR_MEETING_MASTER_LIST, INSERT_UPDATE_VISITOR_MEETING_MASTER, DELETE_VISITOR_MEETING_MASTER } from "../../../../utils/constants";


export const insertUpdateVisitorMeetingMaster_action = (visitorMeetinglist) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            visitorMeetinglist: visitorMeetinglist
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosPost(insertUpdateVisitorMeetingMasterUrl, params, headers)

        dispatch({
            type: INSERT_UPDATE_VISITOR_MEETING_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getVisitorMeetingMasterList_action = () => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosGet(getVisitorMeetingMasterListUrl, params, headers)

        dispatch({
            type: GET_VISITOR_MEETING_MASTER_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const deleteVisitorMeetingMaster_action = (deleteId) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            VisitorMeetingBookingDataID: deleteId
        }
        console.log("deleteExhibitionDocument_action Action------->", params)

        const res = await axiosGet(deleteVisitorMeetingMasterUrl, params, headers)

        dispatch({
            type: DELETE_VISITOR_MEETING_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}